import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const inicialogin = () => {
    return async dispatch => {
        dispatch({
            type: types.LOGINGERENCIAMENTO.INICIALOGIN,
            payload: {}
        })
    }
}

export const validaacesso = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.post('login',
                { 
                    ...filtro
                },            
                { 
                    headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                    } 
                }               
            );

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.VALIDAACESSO);

            return response.data;
        }catch(error){
            if(error.response.status === 401 && error.response.statusText === 'Unauthorized'){
                dispatchresponse(dispatch, {result: false},types.LOGIN.VALIDAACESSO);
            }else{
                dispatchresponseerror(dispatch, error);
            }
        }
    }
}

export const codigoresetsenha = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('login/resetsenha',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.CODIGO_RESETSENHA);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const codigovalidacacadastro = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('login/codigovalidacao',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.CODIGO_VALIDACAD);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const validacacadastro = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('login/validacao',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.VALIDACAD);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('login/pesquisa/codigo',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.PESQUISA);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('login/novoatualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.ATUALIZALOGIN);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const atualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('login/atualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGINGERENCIAMENTO.ATUALIZALOGINDADOS);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}